"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.imageAsFullImageSrc = void 0;

var imageAsFullImageSrc = function imageAsFullImageSrc(image) {
  var sep = '/';

  if (image && image[0] === '/') {
    sep = '';
  }

  return "/api/img/f".concat(sep).concat(image);
};

exports.imageAsFullImageSrc = imageAsFullImageSrc;